import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css'

console.log(JSON.stringify(process.env, null, 2))

const colors = {
  primary: process.env.VUE_APP_COLOR_PRIMARY,
  secondary: process.env.VUE_APP_COLOR_SECONDARY,
  accent: process.env.VUE_APP_COLOR_ACCENT,
  error: process.env.VUE_APP_COLOR_ERROR,
  info: process.env.VUE_APP_COLOR_INFO,
  success: process.env.VUE_APP_COLOR_SUCCESS,
  warning: process.env.VUE_APP_COLOR_WARNING
}

console.log(`colors: ${JSON.stringify(colors)}`)

const opts = {
  icons: {
    iconfont: 'md'
  },
  theme: {
    dark: false,
    themes: {
      light: colors,
      dark: colors
    }
  }
}

Vue.use(Vuetify)

export default new Vuetify(opts);
